import  { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { IProfile, AccountType } from '../models';


export const useAccountContext = () => {
    // USER ID
    const [userId, setUserId] = useState<any>(
        () => {
            const localStorageValue = window.sessionStorage.getItem("userId");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue !== 'undefined')? localStorageValue : '';
        }
    );
    useEffect(() => {
        window.sessionStorage.setItem("userId", userId);
    }, [userId]);

    // ACCOUNT TYPE
    const [accountType, setAccountType] = useState<any>(
        () => {
            const localStorageValue = window.sessionStorage.getItem("accountType");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue !== 'undefined')? localStorageValue : '';
        }
    );
    useEffect(() => {
        window.sessionStorage.setItem("accountType", accountType);
    }, [accountType]);

    // SCAN RESULT
    const [scanResult, setScanResult] = useState<string>(
        () => {
            const localStorageValue = window.sessionStorage.getItem("scanResult");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue !== 'undefined')? localStorageValue : '';
        }
    );
    useEffect(() => {
        window.sessionStorage.setItem("scanResult", scanResult);
    }, [scanResult]);

    // SIGN IN
    const [signedIn, setSignedIn] = useState<boolean>(
        () => {
            const localStorageValue = window.localStorage.getItem("signedIn");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue === 'true')? true : false;
        }
    );
    useEffect(() => {
        window.localStorage.setItem("signedIn", signedIn.toString());
    }, [signedIn]);

    // IS RECOVERING PASSWORD
    const [isRecoveringPassword, setIsRecoveringPassword] = useState<boolean>(
        () => {
            const localStorageValue = window.localStorage.getItem("isRecoveringPassword");
            return (localStorageValue && localStorageValue === 'true')? true : false;
        }
    );
    useEffect(() => {
        window.localStorage.setItem("isRecoveringPassword", isRecoveringPassword.toString());
    }, [isRecoveringPassword]);
    
    // REQUIRED DOCUMENTS
    const [requiredDocuments, setRequiredDocuments] = useState<any>(
        () => {
            const localStorageValue = window.sessionStorage.getItem("requiredDocuments");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue !== 'undefined')? JSON.parse(localStorageValue) : '';
        }
    );
    useEffect(() => {
        window.sessionStorage.setItem("requiredDocuments", JSON.stringify(requiredDocuments));
    }, [requiredDocuments]);


    // Phone Validation
    const [phoneValidation, setPhoneValidation] = useState<any>(
        () => {
            const localStorageValue = window.sessionStorage.getItem("phoneValidation");
            // console.log('signed in: ', localStorageValue)
            return (localStorageValue && localStorageValue !== 'undefined')? JSON.parse(localStorageValue) : '';
        }
    );
    useEffect(() => {
        window.sessionStorage.setItem("phoneValidation", JSON.stringify(phoneValidation));
    }, [phoneValidation]);

    // session id 
    const [frontSessionId, setFrontSessionId] = useState<string>(
        () => {
            const cookieValue = Cookies.get("frontSessionId")
            return (cookieValue && cookieValue !== 'undefined')? cookieValue : '';
        }
    );

    useEffect(() => {
        if (!frontSessionId){
            const short = require('short-uuid');
            const idValue = short.generate();
            Cookies.set("frontSessionId", idValue, { sameSite: 'strict' })
            setFrontSessionId(idValue)
        }
    }, [frontSessionId]);


    // device id 
    const [deviceId, setDeviceId] = useState<string>(
        () => {
            const cookieValue = Cookies.get("deviceId")
            return (cookieValue && cookieValue !== 'undefined')? cookieValue : '';
        }
    );

    useEffect(() => {
        Cookies.set("deviceId", deviceId, {expires: 1, sameSite: 'strict' })
    }, [deviceId]);


    // PROFILE
    const profileStorageValue = window.sessionStorage.getItem("profile");
    const [profile, setProfile] = useState<IProfile>((profileStorageValue && profileStorageValue !== 'undefined')? JSON.parse(profileStorageValue) : ''
    );
    useEffect(() => {
        window.sessionStorage.setItem("profile", JSON.stringify(profile));
    }, [profile]);


    // return { signedIn, setSignedIn, token, setToken, refreshToken, setRefreshToken, frontSessionId, setFrontSessionId, deviceId, setDeviceId, profile, setProfile }
    return { 
        userId, 
        setUserId,
        accountType, 
        setAccountType,
        scanResult, 
        setScanResult,
        signedIn, 
        setSignedIn, 
        requiredDocuments, 
        setRequiredDocuments, 
        frontSessionId, 
        setFrontSessionId, 
        deviceId, 
        setDeviceId, 
        profile, 
        setProfile, 
        phoneValidation, 
        setPhoneValidation,
        isRecoveringPassword, 
        setIsRecoveringPassword

    }

}